export const USER_SAVE = "USER_SAVE";
export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_PAY = "USER_PAY";
export const SET_EVENT = "SET_EVENT";
export const SET_PARTICIPANT = "SET_PARTICIPANT";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const SET_RESERVATIONS_ROOMS = "SET_RESERVATIONS_ROOMS";
export const SET_REGISTER_USER = "SET_REGISTER_USER";
export const SET_PARTICIPANT_EVENT_DATA = "SET_PARTICIPANT_EVENT_DATA";
export const SET_EVENTID = "SET_EVENTID";
export const SET_PROGRAM = "SET_PROGRAM";
export const SET_STATUS = "SET_STATUS";
export const SET_BILLING_DATA = "SET_BILLING_DATA";
export const SET_COURSES = "SET_COURSES";
export const USER_COMPLETE_REGISTER_CARD = "USER_COMPLETE_REGISTER_CARD";
export const SET_BOOKINGS = "SET_BOOKINGS";
export const SET_BILLINGS = "SET_BILLINGS";
